import { HttpHeaders } from '@angular/common/http';
import { Injectable, InjectionToken } from '@angular/core';
//import * as CryptoJS from 'crypto-js';
import { IxellAPIService, CryptSignature, IBillingV1 } from './api.service';
import { Observable } from 'rxjs';
import { ErrorService } from './error.service';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

@Injectable({
    providedIn: 'root'
})
export class PaymentService {

    path: string = "https://secure.payzen.eu/vads-payment/";

    constructor(private apiService: IxellAPIService, private errorService: ErrorService) { }

    /**
    * Fonction qui calcule la signature.
    * params : tableau contenant les champs à envoyer dans le formulaire.
    */
    getSignaturePostForm(params: any) {

        var contenu_signature = "", mode = "";
        //Tri des champs par ordre alphabétique
        params.sort(this.sort_by('name', false, function (a: any) {
            return a.toUpperCase();
        }));
        for (let param of params) {
            //Récupération des champs vads_
            if (param['name'].substr(0, 5) == 'vads_') {

                if (param['name'] == 'vads_ctx_mode') {
                    mode = param['value'];
                }
                //Concaténation avec le séparateur "+"
                contenu_signature += param['value'] + "+";
            }
        }

        var signature;
        const content_ = new CryptSignature();
        content_.cryptMode = mode;
        content_.value = contenu_signature;

        this.apiService.getSignature(content_).subscribe(data => {
            signature = data;
            params.push({ name: 'signature', value: signature });

            var paramsLogged = "";
            for (let key in params) {
                if (params.hasOwnProperty(key)) {
                    paramsLogged += params[key]["name"] + "=" + params[key]["value"] + " ; ";
                }
            }
            this.apiService.addLogsPaiment(paramsLogged).subscribe(data => {
                this.postForm(this.path, params, "post");
            });
        },
            error => {
                console.log(error);
                this.errorService.setErrorLog("IHM", error.status.toString() + " " + error.message, "getSignature", new Date().toString());
            });

        //Ajout de la clé en fin de chaine
        //contenu_signature += this.key;
        //Encodage base64 de la chaine chiffrée avec l'algorithme HMAC-SHA-256
        //var hash = CryptoJS.HmacSHA256(contenu_signature, this.key);
        //var signature2 = CryptoJS.enc.Base64.stringify(hash);
        //console.log("Signature Service " + signature2);

        return signature;
    }

    sort_by(field: any, reverse: any, primer: any) {

        var key = function (x: any) { return primer ? primer(x[field]) : x[field] };

        return function (a: any, b: any) {
            var A = key(a), B = key(b);
            return ((A > B) ? -1 : (A < B) ? +1 : 0) * [-1, 1][+!!reverse];
        }
    }

    postForm(path: any, params: any, method: any) {
        method = method || 'post';

        var form = document.createElement('form');
        form.setAttribute('method', method);
        form.setAttribute('action', path);

        for (let key in params) {
            if (params.hasOwnProperty(key)) {
                var hiddenField = document.createElement('input');
                hiddenField.setAttribute('type', 'hidden');
                hiddenField.setAttribute('name', params[key]["name"]);
                hiddenField.setAttribute('value', params[key]["value"]);

                form.appendChild(hiddenField);
            }
        }
        document.body.appendChild(form);
        form.submit();
    }
}
